<template>
  <input
    v-if="visible"
    type="submit"
    class="btn btn-secondary btn-lg submit-button"
    :value="label"
    :disabled="disabled"
    @click="submitClicked"
  />
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { stripTags } from '../../../lib/string';

export default {
  inject: ['lang'],
  computed: {
    disabled() {
      return (
        this.configurationMode ||
        this.uploadInProgress ||
        !this.isValid ||
        !this.isSaveable ||
        !this.isLoaded ||
        this.ajaxInProgress
      );
    },
    visible() {
      return (
        !this.entry ||
        this.entry.submissionPossible ||
        (!this.entry.submittedAt && this.submissionPossible) ||
        (this.entry.resubmissionRequired && this.resubmissionPossible)
      );
    },
    label() {
      if (
        this.entry &&
        this.entry.resubmissionRequired &&
        this.resubmissionPossible
      ) {
        return stripTags(this.lang.get('entries.form.resubmit'));
      }
      return stripTags(this.lang.get('entries.form.submit'));
    },
    ...mapState('entryForm', ['entry', 'uploadInProgress', 'tabs']),
    ...mapState('entryFormButtons', [
      'resubmissionPossible',
      'submissionPossible'
    ]),
    ...mapGetters('entryForm', [
      'hasMultipleTabs',
      'hasExistingEntry',
      'isValid',
      'isSaveable',
      'isLoaded'
    ]),
    ...mapState('entryFormApi', ['ajaxInProgress']),
    ...mapState('entryFormConfiguration', ['configurationMode'])
  },
  methods: {
    submitClicked() {
      if (this.tabs.length > 1) {
        this.submit();
      } else {
        this.submitForm();
      }
    },
    ...mapActions('entryFormApi', { submit: 'submit', submitForm: 'submitForm' })
  }
};
</script>
